import Vue from 'vue'
import App from './App.vue'
import router from "./router"

//引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'


/**引入自定义的Message，防止多次弹出提示框 */
import {  message } from '@utils/resetMessage';
Vue.use(ElementUI);
Vue.prototype.$message = message;

import 'font-awesome/css/font-awesome.min.css'

// 公共的css
import '../public/css/public.css'
import '@/style/base.scss';

// 引入时间格式化组件
import moment from 'moment'//导入文件
Vue.prototype.$moment = moment;//赋值使用
moment.locale('zh-cn');//需要汉化

// Vue.config.productionTip = false
import Observer from "./observer"
Vue.prototype.$observer=Observer;

// 引入vuex
import store from "./store"

/**
 * 在路由跳转之前判断用户是否登录，如果登录了，则进行跳转，
 * 如果没有登录则跳转到登录页
 */
// 定义白名单
let whiteList=['/login','/img','/dbverify','/resource'];
router.beforeEach(async (to, from, next) => {
  // 检查是否登录
  if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
    next()
  } else {
    // 执行登录操作
    await store.dispatch('checklogin');
    next();
  }
  
});
//自定义指令
Vue.directive('loadmore', {
  bind(el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper')
    selectWrap.addEventListener('scroll', function() {
      let sign = 10
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
      if (scrollDistance <= sign) {
        binding.value()
      }
    })
  }
});

// 事件总线
Vue.prototype.$bus = new Vue(); 

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
